// =============================================================================
// AGENT 4 — STRATEG KONWERSJI: FORMULARZ LEAD GEN
// Używa Formspree (statyczny endpoint) — zero backendu, działa na GitHub Pages.
// Endpoint czytany z VITE_FORMSPREE_ENDPOINT (.env.local)
// =============================================================================

import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { COPY } from '../../copy/microcopy';
import type { LeadFormData } from '../../types/models';
import { useGame } from '../../store/gameStore';

const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;

const isFormConfigured = 
  typeof EMAILJS_SERVICE_ID === 'string' && EMAILJS_SERVICE_ID.length > 0 &&
  typeof EMAILJS_TEMPLATE_ID === 'string' && EMAILJS_TEMPLATE_ID.length > 0 &&
  typeof EMAILJS_PUBLIC_KEY === 'string' && EMAILJS_PUBLIC_KEY.length > 0;

function ResiCraftWordmark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 514 152" role="img" aria-label="ResiCraft" xmlns="http://www.w3.org/2000/svg">
      <rect x="25" y="32" width="88" height="88" rx="28.16" fill="#FFD41F" />
      <path fillRule="evenodd" clipRule="evenodd" d="M25 85.3421L57.8258 85.3421C61.3348 92.3199 68.6515 97.1204 77.1101 97.1201C84.8371 97.1201 91.6108 93.1145 95.3997 87.1024L77.8894 87.1024L74.6272 81.5513L71.365 76.0004L74.6272 70.4492L77.8894 64.8984L95.4 64.8984C91.6108 58.8863 84.8371 54.8801 77.1101 54.8801C68.6511 54.8801 61.3348 59.6803 57.8258 66.6587L25 66.6587L25 72.548L43.6728 72.548C45.6055 72.548 47.1867 74.1013 47.1867 76.0001C47.1867 77.8989 45.6055 79.4525 43.6728 79.4525L25 79.4525L25 85.3421Z" fill="#040A1D" />
      <path d="M129 70.1132C129 57.2528 135.635 52 148.72 52H156V60.1509H151.485C142.823 60.1509 139.782 64.4075 139.782 72.9208V100H129V70.1132Z" fill="#040A1D" />
      <path d="M181.395 100C165.759 100 163 91.2239 163 75.6828C163 56.4851 169.99 51 186.546 51C200.342 51 210 54.6567 210 70.1978C210 75.6828 207.977 79.3396 202.458 79.3396H174.129C174.129 86.653 175.417 91.7724 184.614 91.7724H208.436V100H181.395ZM196.479 71.1119C198.595 71.1119 198.871 69.6493 198.871 68.278C198.871 61.8787 192.984 59.2276 186.546 59.2276C177.348 59.2276 174.129 62.8843 174.129 71.1119H196.479Z" fill="#040A1D" />
      <path d="M217.632 91.8491H244.553C246.721 91.8491 248.979 90.6717 248.979 87.5019C248.979 82.4302 243.288 82.0679 238.952 80.8L229.737 78.2642C219.439 75.4566 217 71.2 217 64.317C217 55.6226 221.065 52 230.731 52H257.742V60.1509H232.357C228.924 60.1509 227.298 60.966 227.298 64.4981C227.298 68.5736 231.273 69.6604 234.796 70.6566L245.095 73.5547C253.586 75.9094 260 77.9925 260 87.7736C260 95.1094 257.38 100 248.256 100H217.632V91.8491Z" fill="#040A1D" />
      <path d="M267 45.7627V36H278V45.7627H267ZM267 52.0904H278V100H267V52.0904Z" fill="#040A1D" />
      <path d="M308.323 60.1509C297.117 60.1509 296.024 66.8528 296.024 75.9094C296.024 84.966 297.117 91.8491 308.323 91.8491H327V100H305.681C289.282 100 285 90.4 285 75.9094C285 61.4189 289.282 52 305.681 52H325.907V60.1509H308.323Z" fill="#040A1D" />
      <path d="M334 70.1132C334 57.2528 340.635 52 353.72 52H361V60.1509H356.485C347.823 60.1509 344.782 64.4075 344.782 72.9208V100H334V70.1132Z" fill="#040A1D" />
      <path d="M399.288 52C408.491 52 413 57.9774 413 66.1283V91.8491C413 97.283 410.239 100 404.718 100H380.147C371.865 100 368 95.0189 368 85.0566C368 76 371.865 70.1132 380.147 70.1132H402.233V67.034C402.233 62.5057 400.025 60.1509 395.423 60.1509H371.589V52H399.288ZM384.288 78.2642C380.607 78.2642 379.135 80.5283 379.135 85.0566C379.135 89.5849 380.607 91.8491 384.288 91.8491H399.472C401.313 91.8491 402.233 90.9434 402.233 89.1321V78.2642H384.288Z" fill="#040A1D" />
      <path d="M426.827 100V60.226H420V52.0904H426.827C426.827 39.435 436.238 36 448.232 36C449.155 36 450.077 36.0904 451 36.0904V43.8644C450.354 43.774 449.801 43.774 449.155 43.774C443.25 43.774 437.622 44.226 437.622 52.0904H451V60.226H437.622V100H426.827Z" fill="#040A1D" />
      <path d="M482.364 100C471.455 100 464.636 96.0686 464.636 84.1829V59.7714H458V51.5429H464.636V36H475.273V51.5429H489V59.7714H475.273V81.9886C475.273 89.3029 479.091 91.7714 486.364 91.7714H489V100H482.364Z" fill="#040A1D" />
    </svg>
  );
}

interface UnsentLead extends LeadFormData {
  matchPercentage: number;
  timeSpentSeconds: number;
  timestamp: number;
}

export function LeadForm() {
  const { state } = useGame();
  const [formData, setFormData] = useState<LeadFormData>({ name: '', email: '', company: '' });
  const [errors, setErrors] = useState<Partial<Record<keyof LeadFormData, string>>>({});
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const validate = (): boolean => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim()) newErrors.name = COPY.lead.validationRequired;
    if (!formData.email.trim()) {
      newErrors.email = COPY.lead.validationRequired;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = COPY.lead.validationEmail;
    }
    if (!formData.company.trim()) newErrors.company = COPY.lead.validationRequired;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormConfigured) {
      setStatus('error');
      return;
    }
    if (!validate()) return;

    setStatus('submitting');
    const templateParams = {
      name: formData.name,
      email: formData.email,
      company: formData.company,
      matchPercentage: state.score?.matchPercentage ?? 0,
      timeSpentSeconds: state.score?.timeSpentSeconds ?? 0,
    };

    try {
      const timeoutPromise = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), 10000)
      );

      await Promise.race([
        emailjs.send(
          EMAILJS_SERVICE_ID!,
          EMAILJS_TEMPLATE_ID!,
          templateParams,
          { publicKey: EMAILJS_PUBLIC_KEY! }
        ),
        timeoutPromise
      ]);
      setStatus('success');
    } catch (err) {
      setStatus('error');

      // Backup to localStorage
      try {
        const key = 'resicraft_unsent_leads';
        const existingDataStr = localStorage.getItem(key);
        const existingList: UnsentLead[] = existingDataStr ? JSON.parse(existingDataStr) : [];
        
        const isDuplicate = existingList.some((item) => 
          item.email === formData.email && 
          item.timeSpentSeconds === templateParams.timeSpentSeconds
        );
        
        if (!isDuplicate) {
          existingList.push({
            ...formData,
            matchPercentage: templateParams.matchPercentage,
            timeSpentSeconds: templateParams.timeSpentSeconds,
            timestamp: Date.now(),
          });
          localStorage.setItem(key, JSON.stringify(existingList));
        }
      } catch (backupErr) {
        console.error('Failed to backup lead to localStorage:', backupErr);
      }
    }
  };

  return (
    <form className="lead-form" onSubmit={handleSubmit} noValidate>
      {status === 'success' ? (
        <div className="lead-form__success-container">
          <div className="lead-form__success-icon" aria-hidden="true">✓</div>
          <h2 className="lead-form__success-title">Dziękujemy!</h2>
          <p className="lead-form__success-text">{COPY.results.leadSent}</p>
        </div>
      ) : (
        <>
          <div className="lead-form__brand">
            <ResiCraftWordmark className="lead-form__logo" />
          </div>
          <div className="lead-form__cta">{COPY.results.leadCta}</div>

          {(['name', 'email', 'company'] as const).map((field) => (
            <div key={field} className="lead-form__field">
              <input
                className="lead-form__input"
                type={field === 'email' ? 'email' : 'text'}
                placeholder={COPY.lead[`${field}Placeholder`]}
                value={formData[field]}
                onChange={(e) => setFormData((prev) => ({ ...prev, [field]: e.target.value }))}
                aria-invalid={!!errors[field]}
                autoComplete={field === 'email' ? 'email' : field === 'name' ? 'name' : 'organization'}
              />
              <span
                className="lead-form__error"
                role="alert"
                style={{ visibility: errors[field] ? 'visible' : 'hidden' }}
              >
                {errors[field] || '\u00A0'}
              </span>
            </div>
          ))}

          <p className="lead-form__privacy">{COPY.lead.privacyNote}</p>

          <button
            className="lead-form__submit"
            type="submit"
            disabled={status === 'submitting' || !isFormConfigured}
          >
            {status === 'submitting' ? '...' : COPY.results.leadButton}
          </button>

          <div className="lead-form__status-wrapper">
            {status === 'submitting' && (
              <span className="lead-form__submitting" role="status" style={{ color: 'var(--color-primary)' }}>
                Wysyłanie danych...
              </span>
            )}

            {!isFormConfigured && (
              <span className="lead-form__error lead-form__error--bottom" role="alert">
                {COPY.lead.missingConfig}
              </span>
            )}

            {status === 'error' && isFormConfigured && (
              <div className="lead-form__error-container" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
                <span className="lead-form__error lead-form__error--bottom" role="alert">
                  {COPY.lead.errorGeneral}
                </span>
                <button
                  type="submit"
                  className="lead-form__retry-btn"
                  style={{
                    background: 'rgba(255, 212, 31, 0.12)',
                    border: '1px solid var(--color-primary)',
                    color: 'var(--color-primary)',
                    borderRadius: '999px',
                    padding: '0.4rem 1rem',
                    fontSize: '0.85rem',
                    fontWeight: 800,
                    cursor: 'pointer',
                    alignSelf: 'flex-start',
                    transition: 'background 0.2s',
                  }}
                >
                  {COPY.lead.retryButton}
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </form>
  );
}
